import * as types from '../constants/actionTypes';
import { CALL_API } from '../helpers/api';

export const actions = {
    searchStatuses: (filterRequest) =>
        (dispatch) => {
            return dispatch({
                [CALL_API]: {
                    endpoint: 'status/search',
                    method: 'POST',
                    body: filterRequest,
                    types: [
                        types.SEARCH_STATUS_REQUEST,
                        types.SEARCH_STATUS_SUCCESS,
                        types.SEARCH_STATUS_FAILURE
                    ]
                }
            });
        },

    saveStatus: (status) =>
        (dispatch) => {
            if (status.id === 0) {
                // Create
                return dispatch({
                    [CALL_API]: {
                        endpoint: 'status/create',
                        method: 'POST',
                        body: status,
                        types: [
                            types.CREATE_STATUS_REQUEST,
                            types.CREATE_STATUS_SUCCESS,
                            types.CREATE_STATUS_FAILURE
                        ]
                    }
                });
            } else {
                // Update
                return dispatch({
                    [CALL_API]: {
                        endpoint: 'status/update',
                        method: 'PUT',
                        body: status,
                        types: [
                            types.UPDATE_STATUS_REQUEST,
                            types.UPDATE_STATUS_SUCCESS,
                            types.UPDATE_STATUS_FAILURE
                        ]
                    }
                });
            }
        }
}
